import AVALIACAO_SESSOES from './AVALIACAO_SESSOES';
import AVALIACAO_MODELO from './AVALIACAO_MODELO';

// Obtém todos os labels dos modelos dinamicamente
const ALL_MODELOS = Object.values(AVALIACAO_MODELO).map(modelo => modelo.label);

const AVALIACAO_QUESTOES = {
  1: {
    id: 1,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Classificação de qualidade de gestão [agências de rating]',
    slug: 'classificacao-qualidade-gestao-agencias-rating',
    peso: null,
    modelos: ALL_MODELOS.filter(
      xLabel => xLabel !== AVALIACAO_MODELO.modelo_fundo_investimento_participacoes.label
    )
  },
  2: {
    id: 2,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Ativos sob gestão (AUM) consolidados – Brasil + Exterior',
    slug: 'aum-consolidado-brasil-exterior',

    peso: 2,
    modelos: ALL_MODELOS
  },
  3: {
    id: 3,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Evolução do AUM consolidado no período avaliado',
    slug: 'evolucao-aum-consolidado',

    peso: 1,
    modelos: ALL_MODELOS
  },
  4: {
    id: 4,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Experiência em anos da equipe de gestão (tempo na gestora + anterior)',
    slug: 'experiencia-equipe-gestao',

    peso: 3,
    modelos: ALL_MODELOS
  },
  5: {
    id: 5,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Experiência em anos da equipe de riscos (tempo na gestora + anterior)',
    slug: 'experiencia-equipe-riscos',

    peso: 2,
    modelos: ALL_MODELOS
  },
  6: {
    id: 6,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Formação técnica da equipe de gestão',
    slug: 'formacao-equipe-gestao',

    peso: 1,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_fundo_passivo.label)
  },
  7: {
    id: 7,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Formação técnica da equipe de riscos',
    slug: 'formacao-equipe-riscos',

    peso: 1,
    modelos: ALL_MODELOS
  },
  8: {
    id: 8,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Manutenção da equipe de gestão',
    slug: 'manutencao-equipe-gestao',

    peso: 1,
    modelos: ALL_MODELOS
  },
  9: {
    id: 9,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Manutenção da equipe de riscos',
    slug: 'manutencao-equipe-riscos',

    peso: 1,
    modelos: ALL_MODELOS
  },
  10: {
    id: 10,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Dependência de pessoa chave',
    slug: 'dependencia-pessoa-chave',

    peso: 1,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_fundo_passivo.label)
  },
  11: {
    id: 11,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Tempo de dedicação dos membros da gestão ao fundo',
    slug: 'dedicacao-membros-gestao',

    peso: 1,
    modelos: ALL_MODELOS.filter(
      xLabel =>
        ![
          AVALIACAO_MODELO.modelo_fundo_passivo.label,
          AVALIACAO_MODELO.modelo_fundo_credito_privado.label,
          AVALIACAO_MODELO.modelo_fundo_considerado_ativo_final.label,
          AVALIACAO_MODELO.modelo_demais_fundos.label
        ].includes(xLabel)
    )
  },
  12: {
    id: 12,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Uso de ferramentas/serviços especializados',
    slug: 'uso-ferramentas-especializadas',

    peso: 1,
    modelos: ALL_MODELOS
  },
  13: {
    id: 13,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Consistência dos processos de gerenciamento de risco de crédito',
    slug: 'consistencia-gerenciamento-risco-credito',

    peso: 1,
    modelos: ALL_MODELOS.filter(
      xLabel => ![AVALIACAO_MODELO.modelo_demais_fundos.label].includes(xLabel)
    )
  },
  14: {
    id: 14,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Consistência dos processos de gerenciamento de risco de mercado',
    slug: 'consistencia-gerenciamento-risco-mercado',

    peso: 1,
    modelos: ALL_MODELOS
  },
  15: {
    id: 15,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Consistência dos processos de gerenciamento de risco de liquidez',
    slug: 'consistencia-gerenciamento-risco-liquidez',

    peso: 1,
    modelos: ALL_MODELOS
  },
  16: {
    id: 16,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Consistência dos processos de gerenciamento de risco legal',
    slug: 'consistencia-gerenciamento-risco-legal',

    peso: 1,
    modelos: ALL_MODELOS
  },
  17: {
    id: 17,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Consistência dos processos de gerenciamento de risco operacional',
    slug: 'consistencia-gerenciamento-risco-operacional',

    peso: 1,
    modelos: ALL_MODELOS
  },
  18: {
    id: 18,
    sessao_id: AVALIACAO_SESSOES.potencialidade_fiduciaria.id,
    sessao: AVALIACAO_SESSOES.potencialidade_fiduciaria.sessao,
    sessao_label: AVALIACAO_SESSOES.potencialidade_fiduciaria.label,
    questao: 'Regularidade na prestação de informações',
    slug: 'regularidade-prestacao-informacoes',

    peso: 1,
    modelos: ALL_MODELOS.filter(
      xLabel =>
        ![
          AVALIACAO_MODELO.modelo_fundo_investimento_participacoes.label,
          AVALIACAO_MODELO.modelo_fundo_considerado_ativo_final.label
        ].includes(xLabel)
    )
  },
  19: {
    id: 19,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Gestora independente',
    slug: 'gestora-independente',

    peso: 1,
    modelos: ALL_MODELOS
  },
  20: {
    id: 20,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Skin in the game',
    slug: 'skin-in-the-game',

    peso: 1,
    modelos: ALL_MODELOS
  },
  21: {
    id: 21,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Eficácia dos processos/área de compliance',
    slug: 'eficacia-processos-compliance',

    peso: 2,
    modelos: ALL_MODELOS
  },
  22: {
    id: 22,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Tratamento dos investimentos de diretores e equipe de gestão',
    slug: 'tratamento-investimento-diretores-gestao',

    peso: 1,
    modelos: ALL_MODELOS
  },
  23: {
    id: 23,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Critérios de remuneração da equipe de riscos da gestora',
    slug: 'criterios-remuneracao-equipe-riscos',

    peso: 1,
    modelos: ALL_MODELOS
  },
  24: {
    id: 24,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Nível de segregação de funções de gestão, administração e custódia',
    slug: 'nivel-segregacao-funcoes',

    peso: 2,
    modelos: ALL_MODELOS
  },
  25: {
    id: 25,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Incorporação de aspectos ASG nos processos decisórios de investimentos',
    slug: 'incorporacao-asg',

    peso: 2,
    modelos: ALL_MODELOS
  },
  26: {
    id: 26,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Adesão a princípios de investimentos responsáveis',
    slug: 'adesao-investimentos-responsaveis',

    peso: 1,
    modelos: ALL_MODELOS
  },
  27: {
    id: 27,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Adesão ao Código de Administração de Recursos de Terceiros da Anbima',
    slug: 'adesao-codigo-anbima',

    peso: 1,
    modelos: ALL_MODELOS
  },
  28: {
    id: 28,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Cumprimento de background check regulatório da gestora do fundo',
    slug: 'background-check-gestora',

    peso: 1,
    modelos: ALL_MODELOS
  },
  29: {
    id: 29,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Cumprimento de background check regulatório da administradora do fundo',
    slug: 'background-check-administradora',

    peso: 1,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_gestora.label)
  },
  30: {
    id: 30,
    sessao_id: AVALIACAO_SESSOES.conflitos_asg.id,
    sessao: AVALIACAO_SESSOES.conflitos_asg.sessao,
    sessao_label: AVALIACAO_SESSOES.conflitos_asg.label,
    questao: 'Cumprimento de background check regulatório da custodiante do fundo',
    slug: 'background-check-custodiante',

    peso: 1,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_gestora.label)
  },
  31: {
    id: 31,
    sessao_id: AVALIACAO_SESSOES.condicoes_regulamentares.id,
    sessao: AVALIACAO_SESSOES.condicoes_regulamentares.sessao,
    sessao_label: AVALIACAO_SESSOES.condicoes_regulamentares.label,
    questao: 'Previsão de obediência à norma CMN das EFPC',
    slug: 'obediencia-norma-cmn-efpc',

    peso: 2,
    modelos: ALL_MODELOS.filter(
      xLabel =>
        ![
          AVALIACAO_MODELO.modelo_gestora.label,
          AVALIACAO_MODELO.modelo_fundo_investimento_participacoes.label,
          AVALIACAO_MODELO.modelo_fundo_considerado_ativo_final.label
        ].includes(xLabel)
    )
  },
  32: {
    id: 32,
    sessao_id: AVALIACAO_SESSOES.condicoes_regulamentares.id,
    sessao: AVALIACAO_SESSOES.condicoes_regulamentares.sessao,
    sessao_label: AVALIACAO_SESSOES.condicoes_regulamentares.label,
    questao: 'Tipo de investidor',
    slug: 'tipo-investidor',

    peso: 1,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_gestora.label)
  },
  33: {
    id: 33,
    sessao_id: AVALIACAO_SESSOES.condicoes_regulamentares.id,
    sessao: AVALIACAO_SESSOES.condicoes_regulamentares.sessao,
    sessao_label: AVALIACAO_SESSOES.condicoes_regulamentares.label,
    questao: 'Taxa máxima de administração (TMA) [desconsiderar taxa de performance]',
    slug: 'taxa-maxima-administracao',

    peso: 2,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_gestora.label)
  },
  34: {
    id: 34,
    sessao_id: AVALIACAO_SESSOES.condicoes_regulamentares.id,
    sessao: AVALIACAO_SESSOES.condicoes_regulamentares.sessao,
    sessao_label: AVALIACAO_SESSOES.condicoes_regulamentares.label,
    questao: 'Uso de derivativos somente para proteção',
    slug: 'uso-derivativos-protecao',

    peso: 1,
    modelos: ALL_MODELOS.filter(
      xLabel =>
        ![
          AVALIACAO_MODELO.modelo_gestora.label,
          AVALIACAO_MODELO.modelo_fundo_investimento_participacoes.label,
          AVALIACAO_MODELO.modelo_fundo_considerado_ativo_final.label
        ].includes(xLabel)
    )
  },
  35: {
    id: 35,
    sessao_id: AVALIACAO_SESSOES.condicoes_regulamentares.id,
    sessao: AVALIACAO_SESSOES.condicoes_regulamentares.sessao,
    sessao_label: AVALIACAO_SESSOES.condicoes_regulamentares.label,
    questao: 'Vedação de crédito privado em fundos que não são de crédito',
    slug: 'vedacao-credito-privado',

    peso: 1,
    modelos: ALL_MODELOS.filter(
      xLabel =>
        ![
          AVALIACAO_MODELO.modelo_gestora.label,
          AVALIACAO_MODELO.modelo_fundo_investimento_participacoes.label,
          AVALIACAO_MODELO.modelo_fundo_credito_privado.label,
          AVALIACAO_MODELO.modelo_fundo_considerado_ativo_final.label
        ].includes(xLabel)
    )
  },
  36: {
    id: 36,
    sessao_id: AVALIACAO_SESSOES.condicoes_regulamentares.id,
    sessao: AVALIACAO_SESSOES.condicoes_regulamentares.sessao,
    sessao_label: AVALIACAO_SESSOES.condicoes_regulamentares.label,
    questao: 'Restrição de alocação em ativos pertencentes ao grupo da gestora',
    slug: 'restricao-alocacao-ativos-grupo-gestora',

    peso: 1,
    modelos: ALL_MODELOS.filter(xLabel => xLabel !== AVALIACAO_MODELO.modelo_gestora.label)
  }
};

export default AVALIACAO_QUESTOES;
